import Vue from 'vue';
import Component from 'vue-class-component';

import SubjectCard from '../../../components/SubjectCard/SubjectCard.vue';
import SemesterSubjectForm from '../../../components/Forms/SemesterSubject/SemesterSubjectForm.vue';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner.vue';
import APIService from '../../../services/APIService';
import DashboardResponse from '../../../models/responses/DashboardResponse';
import SemesterResponse from '../../../models/responses/SemesterResponse';

/**
 * The Dashboard which holds semester and subject information visible to an apprentice.
 */
@Component({
  name: 'ApprenticeDashboardView',
  template: '#apprentice-dashboard',
  components: {
    SubjectCard,
    SemesterSubjectForm,
    LoadingSpinner,
  },
})
export default class ApprenticeDashboardView extends Vue {
  private dashboardResponse: DashboardResponse = {
    currentSemester: null,
    semesters: [],
    currentSubjects: [],
  };
  private loading = false;
  private formType = 'semester';

  get isSemesterSubjectFormOpen(): boolean {
    return this.$store.state.isSemesterSubjectFormOpen;
  }

  get selectedSemester(): SemesterResponse | null {
    return this.$store.state.selectedSemester;
  }

  /**
   * Fetches apprentice dashboard data from the backend.
   */
  async mounted() {
    const semesterId = this.$route.query.semester as string | undefined;
    await this.getDashboardResponse(semesterId);
  }

  /**
   * Resets the local state and fetches the dashboard information.
   *
   * @param semesterId - optional id of semester
   */
  private async reloadDashboard(semesterId?: string) {
    this.dashboardResponse = {
      currentSemester: null,
      semesters: [],
      currentSubjects: [],
    };
    this.getDashboardResponse(semesterId);
  }

  public async setSemester(tabElement: HTMLSdxTabsItemElement) {
    this.$router.replace({ query: { semester: tabElement.id } });
    this.dashboardResponse.currentSubjects = [];
    await this.getDashboardResponse(tabElement.id);
  }

  /**
   * Gets dashboard response from api service.
   *
   * @param semesterId - id of semester if one is selected
   */
  private async getDashboardResponse(semesterId?: string) {
    this.loading = true;
    this.dashboardResponse = await APIService.getDashboard(semesterId);
    this.$store.commit(
      'setSelectedSemester',
      this.dashboardResponse.currentSemester,
    );
    this.loading = false;
  }

  /**
   * Opens form in create semester mode.
   */
  private openSemForm() {
    this.formType = 'semester';
    this.$store.commit('toggleSemesterSubjectForm');
  }

  /**
   * Opens form in edit semester mode.
   */
  private openSemEditForm() {
    this.formType = 'semester';
    this.$store.commit(
      'setEditSemester',
      this.dashboardResponse.currentSemester,
    );
    this.$store.commit('toggleSemesterSubjectForm');
  }

  /**
   * Opens subject in create mode.
   */
  private openSubjForm() {
    this.formType = 'subject';
    this.$store.commit('toggleSemesterSubjectForm');
  }
}
